import { css } from '@emotion/core'
import openSansBoldWOFF2 from './assets/opensans-bold.woff2'
import openSansSemiBoldWOFF2 from './assets/opensans-semibold.woff2'
import openSansLightWOFF2 from './assets/opensans-light.woff2'
import openSansRegularWOFF2 from './assets/opensans-regular.woff2'

import openSansBoldWOFF from './assets/opensans-bold.woff'
import openSansSemiBoldWOFF from './assets/opensans-semibold.woff'
import openSansLightWOFF from './assets/opensans-light.woff'
import openSansRegularWOFF from './assets/opensans-regular.woff'

import openSansBoldTTF from './assets/opensans-bold.ttf'
import openSansSemiBoldTTF from './assets/opensans-semibold.ttf'
import openSansLightTTF from './assets/opensans-light.ttf'
import openSansRegularTTF from './assets/opensans-regular.ttf'

export default css`
  @font-face {
    font-family: 'Open Sans';
    /* See: https://developers.google.com/web/updates/2016/02/font-display#fallback */
    font-display: fallback;
    src: local('Open Sans'), url(${openSansBoldWOFF2}) format('woff2'), url(${openSansBoldWOFF}) format('woff'),
      url(${openSansBoldTTF}) format('truetype');
    font-weight: 700;
  }
  @font-face {
    font-family: 'Open Sans';
    font-display: fallback;
    src: local('Open Sans'), url(${openSansSemiBoldWOFF2}) format('woff2'), url(${openSansSemiBoldWOFF}) format('woff'),
      url(${openSansSemiBoldTTF}) format('truetype');
    font-weight: 600;
  }
  @font-face {
    font-family: 'Open Sans';
    font-display: fallback;
    src: local('Open Sans'), url(${openSansRegularWOFF2}) format('woff2'), url(${openSansRegularWOFF}) format('woff'),
      url(${openSansRegularTTF}) format('truetype');
    font-weight: 500;
  }
  @font-face {
    font-family: 'Open Sans';
    font-display: fallback;
    src: local('Open Sans'), url(${openSansLightWOFF2}) format('woff2'), url(${openSansLightWOFF}) format('woff'),
      url(${openSansLightTTF}) format('truetype');
    font-weight: 400;
  }

  * {
    /* “Thou shalt use Open Sans everywhere on this site... This is the first and great commandment." - Curtis Barlow (sort of) */
    /* "And the second is like unto it, Thou shalt never use !important to override css values. Except here I guess." - (Zach) */
    font-family: 'Open Sans', sans-serif !important;
  }
`
